//@ts-check
import React from 'react';
import MultiSelectFormInput from '../MultiSelect';
import { useFilterContext, getFieldSchema, getFieldSchemaOperators } from './FilterContext';
/**@type {{ label: string; value: import('./types').EcrionFilterOperator}[]} */

var OPTIONS = [{
  label: 'Starts with',
  value: 'StartsWith'
}, {
  label: 'Ends with',
  value: 'EndsWith'
}, {
  label: 'Is',
  value: 'Equal'
}, {
  label: 'Is not',
  value: 'NotEqual'
}, {
  label: 'Contains',
  value: 'Contains'
}, {
  label: 'Greater than',
  value: 'Greater'
}, {
  label: 'Less than',
  value: 'Less'
}, {
  label: 'In',
  value: 'In'
}, {
  label: 'Not in',
  value: 'NotIn'
}, {
  label: 'Before',
  value: 'DateBefore'
}, {
  label: 'After',
  value: 'DateAfter'
}, {
  label: 'Equal',
  value: 'DateEqual'
}, {
  label: 'NotEqual',
  value: 'DateNotEqual'
}, {
  label: 'Before',
  value: 'TimeBefore'
}, {
  label: 'After',
  value: 'TimeAfter'
}, {
  label: 'Equal',
  value: 'TimeEqual'
}, {
  label: 'NotEqual',
  value: 'TimeNotEqual'
}];
/**
 * @param {import('./types').FormInputFilterExpressionOperatorProps } props
 */

var FilterExpressionOperatorFormInput = function FilterExpressionOperatorFormInput(_ref) {
  var value = _ref.value,
      onChange = _ref.onChange,
      field = _ref.field;

  var _useFilterContext = useFilterContext(),
      disabled = _useFilterContext.disabled,
      variant = _useFilterContext.variant,
      color = _useFilterContext.color,
      schema = _useFilterContext.schema;

  var fieldSchema = getFieldSchema(schema, field);
  if (!fieldSchema) throw new Error("Field schema ".concat(field, " not found"));
  var operators = getFieldSchemaOperators(fieldSchema);
  var options = OPTIONS.filter(function (o) {
    return operators.indexOf(o.value) > -1;
  });
  return React.createElement(MultiSelectFormInput, {
    key: field,
    value: value,
    onChange: onChange,
    options: options,
    disabled: disabled,
    variant: variant,
    color: color,
    searchable: false
  });
};

FilterExpressionOperatorFormInput.defaultProps = {};
export default React.memo(FilterExpressionOperatorFormInput);